import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { HelmetProvider } from "react-helmet-async";
import Dashboard from "./pages/Dashboard";
import Footer from "./components/footer"
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Outlet } from "react-router-dom";



function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <ToastContainer />
        <Outlet />
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
